// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS Spinner INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
var UUSpinner = function UUSpinner(_ref) {
  var className = _ref.className,
    scale = _ref.scale,
    style = _ref.style,
    text = _ref.text,
    textStyle = _ref.textStyle,
    center = _ref.center;
  var centerStyles = center ? ['flex', 'justify-center', 'h-full', 'items-center'] : [];
  return /*#__PURE__*/React.createElement("div", {
    "aria-label": "Loading",
    "aria-live": "polite",
    className: classNames('spinner-container', centerStyles, className),
    style: {
      transform: "scale(".concat(scale, ")")
    }
  }, /*#__PURE__*/React.createElement("svg", {
    className: "spinner",
    style: style,
    width: "66px",
    height: "66px",
    viewBox: "0 0 66 66"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "path",
    fill: "none",
    strokeWidth: "6px",
    strokeLinecap: "round",
    cx: "33",
    cy: "33",
    r: "30"
  })), text && /*#__PURE__*/React.createElement("h4", {
    style: textStyle
  }, text));
};
UUSpinner.propTypes = {
  className: PropTypes.string,
  scale: PropTypes.number,
  style: PropTypes.object,
  text: PropTypes.string,
  textStyle: PropTypes.object,
  center: PropTypes.bool
};
UUSpinner.defaultProps = {
  className: '',
  scale: 1,
  style: {},
  text: '',
  textStyle: {},
  center: false
};
export default UUSpinner;